import { render } from "./BarChart.vue?vue&type=template&id=1df406c8&scoped=true"
import script from "./BarChart.vue?vue&type=script&lang=ts"
export * from "./BarChart.vue?vue&type=script&lang=ts"

import "./BarChart.vue?vue&type=style&index=0&id=1df406c8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1df406c8"

export default script